import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "moudle5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-title" }, [
  /*#__PURE__*/_createElementVNode("p", null, "GLOBAL COVERAGE"),
  /*#__PURE__*/_createElementVNode("div")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "content" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}